export default "__VITE_ASSET__DB2P5kYj__"